import React, { useState } from "react";
import Sidebar from "../components/common/Sidebar";
import AuthNavbar from "../components/common/AuthNavbar";

const DashboardLayout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <React.Fragment>
      <AuthNavbar setIsSidebarOpen={setIsSidebarOpen} />
      <div style={{ display: "flex" }} className="mt-14">
        {/* Sidebar container – no extra width; Sidebar itself provides 240px on desktop */}
        <div className="h-[100vh]">
          <Sidebar isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} />
        </div>

        {/* Main content takes remaining space */}
        <main className="flex-1 w-full h-[100vh] overflow-y-scroll">
          {children}
        </main>
      </div>
    </React.Fragment>
  );
};

export default DashboardLayout;